import { computed } from 'vue'

import { MarketCountryCode } from '@backmarket/http-api/src/api-models/MarketCountryCode'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

// Only US and FR have a mobile plans destination today
// Other markets will be available in the future.
export function useMobilePlansUrl() {
  const { market } = useMarketplace()

  const mobilePlansUrl = computed(() => {
    if (market.countryCode === MarketCountryCode.US) {
      return 'https://www.backmarket.com/en-us/service/visible-by-verizon'
    }

    if (market.countryCode === MarketCountryCode.FR) {
      return 'https://www.backmarket.fr/fr-fr/service/bouygues-telecom'
    }

    return undefined
  })

  return { mobilePlansUrl }
}
